import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4e9f8877")
const _hoisted_1 = {
  key: 0,
  class: "p-d-flex p-jc-between margin-head"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, "Ofertas laborales scrapeadas", -1)
const _hoisted_3 = [
  _hoisted_2
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.currentRoute === 'JobOffersScraperList')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ]))
}